/** @format */
import { useTranslation } from 'next-i18next';
import React, { useContext } from 'react';
import styled from 'styled-components';

import { normalizeIsoCode } from '@toucan/common/helpers/language';

import { MarketContext } from '@toucan/client/global/market';

import { Flag } from '@toucan/client/shared/components/market-flag';

import { getMarketOptionMessage } from './helpers';
import { styles } from './market-options.styles';
import { MarketOptionProps, StyledMarketOptionProps } from './types';

const StyledMarketOption = styled('a')<StyledMarketOptionProps>`
    ${styles}
`;

export const MarketOption = ({
    onClick,
    showTranslations,
    market,
    suggestedMarketLanguage,
}: MarketOptionProps) => {
    const { activeMarket } = useContext(MarketContext);
    const { t } = useTranslation();

    // get the message for the given market, in the language of the active market
    const message = getMarketOptionMessage(
        market.code,
        normalizeIsoCode(activeMarket.iso),
        t
    );

    // get the message for the given market, in the language of the given market
    const translatedMessage = getMarketOptionMessage(
        market.code,
        suggestedMarketLanguage,
        t
    );

    return (
        <StyledMarketOption
            href={`/${market.slug}`}
            onClick={onClick}
            data-testid={`market-option--${market.code}`}
            $showTranslations={showTranslations}
        >
            <div className="flag" data-testid="market-option__flag">
                <Flag marketCode={market.code} />
            </div>
            <div
                className="market-message"
                data-testid="market-option__message"
            >
                {message}
            </div>
            {/* eslint-disable-next-line react/jsx-no-leaked-render -- Legacy code: do not use as an example. */}
            {showTranslations && (
                <div
                    className="market-translation"
                    data-testid="market-option__translated-message"
                >
                    {translatedMessage}
                </div>
            )}
        </StyledMarketOption>
    );
};
